import { editDocumentSkillStep1 } from "./step1";
import { SkillForm } from "@/core/skillForms/types";

export const editDocumentSkillForm: SkillForm = {
  skillId: "edit_document",
  title: "Editar texto",
  steps: [editDocumentSkillStep1],
};
